import LazyYouTubeEmbed from '@/commons/LazyYouTubeEmbed';
import React from 'react';
import {
  FaTools,
  FaCogs,
  FaPumpSoap,
  FaShower,
  FaRecycle,
  FaCheckCircle,
  FaThermometerHalf,
  FaCompressAlt,
} from 'react-icons/fa';

const chemicalWashSteps = [
  {
    icon: <FaTools className="text-3xl text-orange-600" />,
    title: '1. Inspection & Preparation',
    description:
      'Technician inspects the unit and covers nearby furniture and flooring to protect from spills or mess.',
  },
  {
    icon: <FaCogs className="text-3xl text-orange-600" />,
    title: '2. Disassembly',
    description:
      'The aircon unit is powered off and disassembled, including removal of filters and front panels.',
  },
  {
    icon: <FaPumpSoap className="text-3xl text-orange-600" />,
    title: '3. Chemical Application',
    description:
      'Special cleaning agents are applied to evaporator coils, fan blades, and internal components to break down dirt and grime.',
  },
  {
    icon: <FaShower className="text-3xl text-orange-600" />,
    title: '4. Washing The Components',
    description:
      'Components are thoroughly washed under running water or a jet spray to remove loosened contaminants.',
  },
  {
    icon: <FaRecycle className="text-3xl text-orange-600" />,
    title: '5. Vacuuming of Drainage Pipe',
    description:
      'Drainage pipe is vacuumed from FCU or bathroom outlet to eliminate any potential clogs or blockages.',
  },
  {
    icon: <FaCheckCircle className="text-3xl text-blue-500" />,
    title: '6. Reassembly & Testing',
    description:
      'Unit is reassembled, filter is placed back, and the aircon is tested to ensure smooth and efficient performance.',
  },
  {
    icon: <FaCompressAlt className="text-3xl text-blue-500" />,
    title: '7. Compressor Performance Checking',
    description:
      'Condenser unit is checked for performance. Technicians may recommend additional cleaning if needed (extra charges apply).',
  },
  {
    icon: <FaThermometerHalf className="text-3xl text-blue-500" />,
    title: '8. Monitor Refrigerant Gas Level',
    description:
      'Technicians check refrigerant gas level using a gauge. If gas is low, a top-up may be suggested (additional cost).',
  },
];

export const AirconChemicalWashProcess = () => {
  return (
    <section aria-labelledby="chemical-wash-process-title" className="px-2">
      <h2
        id="chemical-wash-process-title"
        className="text-xl md:text-2xl text-center font-bold uppercase text-gray-800"
      >
        8-Step Aircon Chemical Wash Process
      </h2>

      <p className="text-center leading-6 font-medium mt-6 text-gray-600">
        Our <strong>8-step chemical wash</strong> is ideal for deeply clogged or moldy aircon units — restoring full cooling performance and air quality.
      </p>

      <ul
        className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3"
        aria-label="Aircon chemical wash steps"
      >
        {chemicalWashSteps.map((step, index) => (
          <li
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-6 flex flex-col items-center text-center"
            aria-labelledby={`chem-step-title-${index}`}
          >
            <div>{step.icon}</div>
            <h3
              id={`chem-step-title-${index}`}
              className="md:text-lg font-semibold mt-4 text-gray-800"
            >
              {step.title}
            </h3>
            <p className="text-sm leading-6 text-gray-600 mt-2">{step.description}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};
